// src/service/userTransactions/getChargeBack.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../redux/baseQuery";

interface GetChargeBackService {
  response?: any;
}

type ChargeBackParams = {
  page?: any,
  pageSize?: any,
  email?: string;
  status?: string;
  dateFrom?: string;
  dateTo?: string;
};

export const getChargeBack = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: ["ChargeBacks"],
  endpoints: (builder) => ({
    getChargeBack: builder.query<GetChargeBackService, ChargeBackParams | undefined>({
      query: (params) => ({
        url: "/admin/transaction/chargeback",
        method: "GET",
        params,
      }),
      providesTags: ["ChargeBacks"],
    }),
  }),
});
export const { useGetChargeBackQuery } = getChargeBack;
